/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
if (__CLIENT__) {
  window.__nbcnd__ = window.__nbcnd__ || {};

  window.__nbcnd__.adQueue = window.__nbcnd__.adQueue || [];
}

export default function adReady(fn) {
  if (__CLIENT__) {
    window.__nbcnd__.adQueue.push(fn);
  }
}
